import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import { MediaUpload, Notice, Confirm } from './media'
import './media.css'

/*
 * SPONSOR — the logo.
 *
 * The twin of FileUploadSponsor, against its own endpoints:
 *   POST   admin/uploadsponsorlogo         (multipart: file, id — with progress)
 *   DELETE admin/uploadsponsorlogo/{id}
 *   the preview still reads admin/files/sponsorlogo/{id}/{cache-buster}
 *
 * It keeps its own state and its own requests — only the surface is shared, so
 * the two upload panels read as one control used twice.
 */

const FileUploadLogoSponsor = (props) => {

  const [file, setFile] = useState('')
  const [fileName, setFileName] = useState('Please select an MP4 file')
  const [upLoading, setUpLoading] = useState(false)
  const [uploadPercentage, setUploadPercentage] = useState(0)
  const [url, setUrl] = useState('')
  const [title, setTitle] = useState('')
  const [photo, setPhoto] = useState('')
  const [note, setNote] = useState(null)
  const [confirmDel, setConfirmDel] = useState(false)

  const inputRef = useRef(null)

  useEffect(() => {

    loadFile(props.id)

    setUrl(process.env.REACT_APP_API_SERVER + 'admin/uploadsponsorlogo')
    setFileName('Please select an image file')
    setTitle('Upload Sponsor Logo.')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type])


  useEffect(() => {
    loadFile(props.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id])

  const fileChanged = (picked) => {
    if (!picked) return
    if (picked.type.indexOf('image/') > -1) {
      setFile(picked)
      setFileName(picked.name)
      setNote(null)
    } else {
      setFile('')
      setFileName('Please select an image file')
      setNote({ kind: 'crit', text: 'Please Select an IMAGE file' })
    }
  }

  const uploadFile = async e => {
    e.preventDefault()
    if (!file) {
      setNote({ kind: 'crit', text: 'Please select an image file' })
      return
    }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('id', props.id)
    try {
      setUpLoading(true)
      setNote(null)
      axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
        },
        onUploadProgress: ProgressEvent => {
          setUploadPercentage(parseInt(Math.round(ProgressEvent.loaded * 100 / ProgressEvent.total)))
        }
      }).then(res => {
        setUpLoading(false)
        if (inputRef.current) inputRef.current.value = null

        setUploadPercentage(0)
        setFile('')
        setFileName('Please select an image file')

        if (res.data.err == 0) {
          loadFile(props.id)
          props.loadData(props.id)
          setNote({ kind: 'good', text: 'Logo uploaded.' })
        } else {
          setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
        }

      }).catch(err => {
        setUpLoading(false)
        setUploadPercentage(0)
        setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
      })

    } catch (err) {
      setUpLoading(false)
      setUploadPercentage(0)
      setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
    }
  }

  const loadFile = (id) => {

    const t = Date.now()
    setPhoto(process.env.REACT_APP_API_SERVER + 'admin/files/sponsorlogo/' + id + '/' + t)

  }

  const delFile = () => {
    setConfirmDel(false)
    axios.delete(process.env.REACT_APP_API_SERVER + 'admin/uploadsponsorlogo/' + props.id, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    }).then(res => {
      props.loadData(props.id)
      loadFile(props.id)
      setNote({ kind: 'good', text: 'Logo deleted.' })
    }).catch(err => {
      setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
    })
  }

  const hasLogo = !!(props.record && props.record.SponsorLogo)

  return (
    <Panel title="Sponsor Logo" subtitle={title}>
      {confirmDel ? (
        <Confirm
          text={<b>Delete File?</b>}
          confirmLabel="Delete"
          cancelLabel="Cancel"
          onConfirm={delFile}
          onCancel={() => setConfirmDel(false)}
        />
      ) : null}

      <MediaUpload
        inputId="customFile1"
        inputRef={inputRef}
        hint="JPG, PNG or WEBP"
        fileName={fileName}
        onFile={fileChanged}
        onSubmit={uploadFile}
        uploading={upLoading}
        percent={uploadPercentage}
        canSubmit={!!file}
        submitLabel="Upload Sponsor Logo"
        notice={note ? <Notice kind={note.kind} onClose={() => setNote(null)}>{note.text}</Notice> : null}
        preview={photo}
        previewAlt="Sponsor logo"
        hasFile={hasLogo}
        onDelete={() => setConfirmDel(true)}
        deleteLabel="Delete logo"
        emptyPreview="No logo yet"
      />
    </Panel>
  )


}

export default FileUploadLogoSponsor;
